<template>
  <v-row
    no-gutters
    class="past-activity"
  >
    <v-col
      cols="12"
      sm="12"
      md="12"
      class="past-activity-header-col"
    >
      <div class="past-activity-title">
        Past Activity
      </div>

      <div class="search-wrap">
        <v-icon
          v-if="!query"
          size="28"
          class="search-icon"
        >
          mdi-magnify
        </v-icon>

        <textarea
          ref="searchInput"
          v-model.trim="query"
          class="search-input search-input--multiline"
          placeholder="Search Chats"
          rows="1"
          @input="resizeSearchInput"
        />
      </div>

      <div class="search-subtitle">
        {{ searchSubtitle }}
      </div>
    </v-col>

    <v-col
      cols="12"
      sm="12"
      md="12"
      class="past-activity-list-col"
    >
      <past-activity-list
        :sessions="filteredSessions"
        :loading="loading"
        @select-session="selectSession"
        @delete-session="openDeleteDialog"
      />
    </v-col>
  </v-row>
</template>

<script>
import assistantService from '@/ai/services/AssistantService'
import PastActivityList from './PastActivityList.vue'

export default {
  name: 'PastActivity',

  components: {
    PastActivityList
  },

  dataStore: {
    assistantStore: 'AssistantStore'
  },

  data () {
    return {
      query           : '',
      showDeleteDialog: false,
      sessionToDelete : null
    }
  },

  computed: {
    sessions () {
      return this.assistantStore.Sessions.All.Data || []
    },

    loading () {
      return this.assistantStore.Sessions.All.Loading
    },

    filteredSessions () {
      const query = this.query.toLowerCase()

      if (!query) {
        return this.sessions
      }

      return this.sessions.filter(session => {
        const title = (session.title || '').toLowerCase()
        return title.includes(query)
      })
    },

    searchSubtitle () {
      if (!this.query) {
        return 'History'
      }

      if (!this.loading && this.filteredSessions.length === 0) {
        return 'No results found'
      }

      return 'Results'
    }
  },

  mounted () {
    this.resizeSearchInput()
  },

  created () {
    this.getSessions()
  },

  methods: {
    async getSessions () {
      await assistantService.getAllChatSessions()
    },

    async selectSession (session) {
      this.$emit('session-selected')
      await assistantService.selectSession(session)
    },

    openDeleteDialog (session) {
      this.$emit('delete-session', session)
    },

    resizeSearchInput () {
      const el = this.$refs.searchInput
      if (!el) {
        return
      }

      const maxHeight = 120
      el.style.height = 'auto'

      const nextHeight = Math.min(el.scrollHeight, maxHeight)
      el.style.height = `${nextHeight}px`
      el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden'
    }
  }
}
</script>

<style scoped>
.past-activity {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;

  min-width: 0;
  min-height: 0;

  margin: 0;
  padding: 4px 18px 12px;

  overflow: hidden;

  box-sizing: border-box;
}

.past-activity-header-col {
  flex: 0 0 auto !important;

  width: 100%;
  max-width: 100%;

  min-width: 0;

  padding: 6px 0 14px;
}

.past-activity-list-col {
  display: flex;

  flex: 1 1 0 !important;

  width: 100%;
  max-width: 100%;

  min-width: 0;
  min-height: 0;

  padding: 0;

  overflow: hidden;
}

.past-activity-list-col > * {
  flex: 1 1 0;

  width: 100%;

  min-width: 0;
  min-height: 0;

  overflow: hidden;
}

.past-activity-title {
  padding-top: 45px;
  padding-bottom: 30px;
  color: #041f30;
  font-size: 17px;
  font-family: 'Aeonik';
  font-weight: 500;
  line-height: 21px;
  text-align: center;
}

.search-wrap {
  display: flex;
  align-items: center;
  gap: 10px; /* controls icon-placeholder spacing */
  min-height: 50px;
  border: 1px solid #ccd5e4;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.84);
  padding: 0 12px;
}

.search-icon {
  flex: 0 0 auto;
  color: #6c829a !important;
}

.search-input {
  flex: 1;
  min-width: 0;
  min-height: 22px;
  max-height: 120px;
  border: 0;
  outline: none;
  background: transparent;
  resize: none;
  overflow-y: hidden;
  color: #041F30;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  padding: 0;
}

.search-input::placeholder {
  color: #63747D;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}

.search-subtitle {
  padding-top: 24px;
  padding-left: 14px;
  color: #041F30;
  font-size: 13px;
  font-family: 'Inter';
  font-weight: 500;
  line-height: 21px;
}

.search-input--multiline {
  resize: none;
  overflow-y: hidden;
  line-height: 1.4;
  max-height: 120px;
}
</style>
